import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  getTGroupDataEndPoint,
  updateDataEndPoint,
} from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import cloneDeep from "lodash.clonedeep";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  targetingGroupsList: [],
  targetingGroupDetails: {
    group_type: "",
    group_name: "",
    accounts: "",
    modify_access: "",
    upload_file: "",
    categories: "",
  },
  targetingGroupFilterFormValues: {
    organizations: [],
    accounts: [],
    group_types: [],
  },
  targetingGroupFilters: {
    organizations: [],
    accounts: [],
    group_types: [],
  },
  // targetingGroupFilterFormValues: {
  //   accounts: [],
  //   group_types: [],
  // },
  // targetingGroupFilters: {
  //   accounts: [],
  //   group_types: [],
  // },
};

const TargetingGroup = createSlice({
  name: "targetinggroup",
  initialState,
  reducers: {
    resetTargetingGroupForm(state, action) {
      state.targetingGroupDetails = {
        group_type: "",
        group_name: "",
        accounts: "",
        modify_access: "",
        upload_file: "",
        categories: "",
      };
    },
    updateTargetingGroupFiltersFormValues(state, action) {
      let targetingGroupFilters = cloneDeep(
        state.targetingGroupFilterFormValues
      );
      if (action.payload?.action == "delete") {
        targetingGroupFilters = {
          organizations: [],
          accounts: [],
          group_types: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        targetingGroupFilters[type] = data;
      }

      state.targetingGroupFilterFormValues = targetingGroupFilters;
    },

    updateTargetingGroupFilters(state, action) {
      let targetingGroupFilters = cloneDeep(state.targetingGroupFilters);
      targetingGroupFilters.organizations = action.payload.organizations;
      targetingGroupFilters.accounts = action.payload.accounts;
      targetingGroupFilters.group_types = action.payload.group_types;

      state.targetingGroupFilters = targetingGroupFilters;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllTargetingGroupsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllTargetingGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.targetingGroupsList = action.payload.data.results[0];
        }

        state.loading = false;
      })
      .addCase(GetAllTargetingGroupsListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateTargetingGroupDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        InsertUpdateTargetingGroupDetailsThunk.fulfilled,
        (state, action) => {
          if (!action.payload.data?.error) {
            let groupType = action.meta.arg.group_type;
            let targetingGroupData = {
              group_type: action.meta.arg.group_type,
              group_name: action.meta.arg.group_name,
              accounts: action.meta.arg.accounts,
              modify_access: action.meta.arg.modify_access,
              upload_file:
                groupType == "zipcode" ||
                groupType == "bundleid" ||
                groupType == "email" ||
                groupType == "email_sha2_256_lower" ||
                groupType == "email_sha2_256_upper" ||
                groupType == "ipaddress"
                  ? action.meta.arg.upload_file
                  : JSON.parse(action.meta.arg.upload_file),
              categories:
                groupType == "ipaddress" ||
                groupType == "email" ||
                groupType == "email_sha2_256_lower" ||
                groupType == "email_sha2_256_upper"
                  ? action.meta.arg.categories
                  : JSON.parse(action.meta.arg.categories),
            };
            state.targetingGroupDetails = targetingGroupData;
          }
          state.loading = false;
        }
      )
      .addCase(
        InsertUpdateTargetingGroupDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          //state.loading = false;
        }
      )

      .addCase(GetTargetingGroupDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTargetingGroupDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let accountResultData = action.payload.data?.results[1];
          let accounts = [];
          accountResultData.map((info) => {
            accounts.push(info.accountid);
          });
          let groupType = resultData.type;

          let dbcategories = "";
          if (
            groupType == "ipaddress" ||
            groupType == "email" ||
            groupType == "email_sha2_256_lower" ||
            groupType == "email_sha2_256_upper"
          ) {
            dbcategories = resultData.categories;
          } else {
            if (resultData.categories != "") {
              dbcategories = JSON.parse(resultData.categories);
            }
          }
          let targetgroupData = {
            group_name: resultData.name,
            group_type: resultData.type,
            categories: dbcategories,
            upload_file:
              groupType == "zipcode" ||
              groupType == "bundleid" ||
              groupType == "email" ||
              groupType == "email_sha2_256_lower" ||
              groupType == "email_sha2_256_upper" ||
              groupType == "ipaddress"
                ? resultData.active_categories_ui
                : JSON.parse(resultData.active_categories_ui),
            modify_access: resultData.modify_access,
            accounts: accounts,
          };
          state.targetingGroupDetails = targetgroupData;
        }
        state.loading = false;
      })
      .addCase(GetTargetingGroupDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(getTargetingGroupIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTargetingGroupIdThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getTargetingGroupIdThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const GetAllTargetingGroupsListThunk = createAsyncThunk(
  "company/GetAllTargetingGroupsListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var targetingGroupFilters = payload?.targetingGroupFilters;
    let condition = [];
    console.log("targetingGroupFilters:", targetingGroupFilters);
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        " tg.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'"
      );
    }

    if (targetingGroupFilters?.accounts?.length > 0) {
      condition.push(
        " ta.accountid IN ('" +
          targetingGroupFilters?.accounts.join("','") +
          "')"
      );
    } else if (isSysAdmin != 1) {
      let userPubAccounts =
        payload?.authUserData?.user_assoc_accounts?.publisher != undefined &&
        payload?.authUserData?.user_assoc_accounts?.publisher.length > 0
          ? payload?.authUserData?.user_assoc_accounts?.publisher
          : [];
      let userAdvAccounts =
        payload?.authUserData?.user_assoc_accounts?.advertiser != undefined &&
        payload?.authUserData?.user_assoc_accounts?.advertiser.length > 0
          ? payload?.authUserData?.user_assoc_accounts?.advertiser
          : [];
      let userAllAccounts = [...userPubAccounts, ...userAdvAccounts];
      if (userAllAccounts.length > 0) {
        condition.push(
          " ta.accountid IN ('" + userAllAccounts.join("','") + "')"
        );
      } else {
        condition.push("ta.accountid IN ('0')");
      }
    }

    if (targetingGroupFilters?.group_types?.length > 0) {
      condition.push(
        " tg.type IN ('" + targetingGroupFilters?.group_types.join("','") + "')"
      );
    } else {
      condition.push(
        " tg.type IN ('zipcode','latlon','polygon','address','bundleid','email','email_sha2_256_lower','email_sha2_256_upper','ipaddress')"
      );
    }

    let where = " ON ta.groupid=tg.id";
    if (targetingGroupFilters?.organizations.length) {
      condition.push(
        "acc.company_id IN('" +
          targetingGroupFilters?.organizations.join("','") +
          "')  "
      );
      where = " and ta.groupid=tg.id";
    }

    if (condition.length > 0) {
      where += " where " + condition.join(" and ") + "";
    }
    //console.log("where:", where);

    let query = "";
    if (targetingGroupFilters?.organizations.length) {
      query =
        "select tg.id,tg.name,tg.type,GROUP_CONCAT(ta.accountid) AS accountid,(select company from " +
        tablePrefix +
        " accounts  where id=ta.accountid   ) as account_name, tg.creation_date from " +
        tablePrefix +
        "targeting_groups tg LEFT JOIN targetgroups_account_assoc ta ON tg.id = ta.groupid " +
        " INNER JOIN " +
        tablePrefix +
        "accounts AS acc ON ta.accountid = acc.id " +
        where +
        "group by tg.id order by tg.creation_date desc;";
    } else {
      query =
        "select tg.id,tg.name,tg.type,GROUP_CONCAT(ta.accountid) AS accountid,(select company from " +
        tablePrefix +
        " accounts  where id=ta.accountid) as account_name, tg.creation_date from " +
        tablePrefix +
        "targeting_groups tg LEFT JOIN targetgroups_account_assoc ta  " +
        where +
        "group by tg.id order by tg.creation_date desc;";
    }

    console.log("Query:", query);

    const queryBody = {
      queries: [
        {
          // query:
          //   "select tg.id,tg.name,tg.type,GROUP_CONCAT(ta.accountid) AS accountid,(select company from " +
          //   tablePrefix +
          //   " accounts  where id=ta.accountid   ) as account_name, tg.creation_date from " +
          //   tablePrefix +
          //   "targeting_groups tg LEFT JOIN targetgroups_account_assoc ta  " +
          //   where +
          //   " and  ta.accountid!=''   group by tg.id order by tg.creation_date desc",
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateTargetingGroupDetailsThunk = createAsyncThunk(
  "company/InsertUpdateTargetingGroupDetailsThunk",
  async (payload) => {
    //console.log('payload', payload)

    // payload.categories = "";
    // payload.active_categories_ui = "";
    // payload.type = "";
    // payload.segment_type = "";
    // payload.created_by = "";

    let insertUpdateQuery = "";
    let insertTargetQuery = [];
    let updateAccountQuery = [];
    let insertTargetAccoutQuery = [];
    if (payload.action == "add") {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "targeting_groups (id,name,categories,active_categories_ui,type,created_by,modify_access,creation_date,updated) values('" +
        payload.id +
        "','" +
        addslashes(payload.group_name) +
        "','" +
        addslashes(payload.categories) +
        "','" +
        addslashes(payload.upload_file) +
        "','" +
        payload.group_type +
        "','" +
        payload.created_by +
        "','" +
        payload.modify_access +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ") ";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "targeting_groups set name='" +
        addslashes(payload.group_name) +
        "',categories='" +
        addslashes(payload.categories) +
        "',active_categories_ui='" +
        addslashes(payload.upload_file) +
        "',modify_access='" +
        payload.modify_access +
        "',updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "  where id='" +
        payload.id +
        "'";
      updateAccountQuery = [
        {
          query:
            "delete from " +
            tablePrefix +
            "targetgroups_account_assoc where groupid='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
    }

    insertTargetQuery = [
      {
        query: insertUpdateQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    let insertValuesArr = [];
    if (payload.accounts.length > 0) {
      payload.accounts.map((info) => {
        insertValuesArr.push("('" + payload.id + "','" + info + "')");
      });
    }
    if (insertValuesArr.length > 0) {
      insertTargetAccoutQuery = [
        {
          query:
            "insert into " +
            tablePrefix +
            "targetgroups_account_assoc (groupid,accountid) values " +
            insertValuesArr.join(",") +
            "",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
    }
    let queriesArr = [
      ...insertTargetQuery,
      ...updateAccountQuery,
      ...insertTargetAccoutQuery,
    ];
    console.log("queriesArr", queriesArr);

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetTargetingGroupDetailsThunk = createAsyncThunk(
  "company/GetTargetingGroupDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,categories,active_categories_ui,type,modify_access from " +
            tablePrefix +
            "targeting_groups where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select * from " +
            tablePrefix +
            "targetgroups_account_assoc where groupid='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getTargetingGroupIdThunk = createAsyncThunk(
  "company/getTargetingGroupIdThunk",
  async (payload) => {
    const queryBody = {
      // queries: [
      //   {
      //     query:
      //       "select * from " +
      //       tablePrefix +
      //       "targeting_groups where id='" +
      //       payload.id +
      //       "'",
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   },
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    };
    try {
      const response = await axiosApiInstance.post(
        getTGroupDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const { actions, reducer } = TargetingGroup;
// Extract and export each action creator by name
export const {
  resetTargetingGroupForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
  updateTargetingGroupFiltersFormValues,

  updateTargetingGroupFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
